import * as React from 'react';

import {reduxForm} from 'redux-form';
// @ts-expect-error
import type {FormProps} from 'redux-form/lib/types.js.flow';

import {AccountsCircleIcon} from 'shells/icon/svg/accounts-circle-icon';

import type {GetFields_createModalFields as CreateModalField} from 'nutshell-graphql-types';

import type {FlashMessage} from '../../creator/types';

import {DefaultFooter} from '../default-footer/default-footer';
import {FormWrapper} from '../form-wrapper/form-wrapper';

import {getFieldsToDisplay, getFieldComponent} from './helpers';

import styles from '../form-common.module.css';

export const ENTITY_FORM_TYPE = 'accounts';
export const ACCOUNTS_FORM_KEY = 'accounts-modal';

type Props = {
    schema: any;
    isLoading: boolean;
    selectedFields: CreateModalField[];
    handleSubmit: FormProps['handleSubmit'];
    reset: FormProps['reset'];

    submitting: FormProps['submitting'];

    submitFailed: FormProps['submitFailed'];
    onCancelClick: () => void;

    pushFlashMessage: (arg1: FlashMessage) => void;
};

const emptyValues = {
    addresses: [{name: 'address', value: undefined}],
    emails: [{name: 'email', value: undefined}],
    phones: [{name: 'phone', value: undefined}],
    urls: [{name: 'url', value: undefined}],
} as const;

function AccountFormConnectedComponent(props: Props) {
    const renderFooter = () => {
        return (
            <DefaultFooter
                onCancel={handleCancelClick}
                isSaving={props.submitting}
                errorSaving={props.submitFailed}
                buttonText='Add company'
                savingText='Adding company…'
            />
        );
    };

    const handleCancelClick = () => {
        props.onCancelClick();
        props.reset();
    };

    const fields = getFieldsToDisplay({
        schema: props.schema,
        selectedFields: props.selectedFields,
        entityType: ENTITY_FORM_TYPE,
    });
    const fieldComponents = fields.map((field) =>
        getFieldComponent({field, entityType: ENTITY_FORM_TYPE})
    );

    return (
        <form onSubmit={props.handleSubmit} className={styles.form}>
            <FormWrapper
                icon={AccountsCircleIcon}
                // @ts-expect-error
                reset={props.reset}
                footer={renderFooter()}
                isLoading={props.isLoading}
            >
                {fieldComponents}
            </FormWrapper>
        </form>
    );
}

export const AccountFormConnected = reduxForm({
    form: ACCOUNTS_FORM_KEY,
    initialValues: emptyValues,
    // @ts-expect-error
})(AccountFormConnectedComponent);
